import { EditOutlined as EditOutlinedIcon } from "@mui/icons-material";
import { FC, useMemo } from "react";

import { TableActions } from "~/src/components/common/tables/TableActions";

type Props = {
  siteSlug: string;
  moduleId: string;
};

export const FunnelUserTagModuleTableActions: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ siteSlug, moduleId }) => {
  const actionMenus = useMemo(
    () => [
      {
        label: "編集",
        icon: <EditOutlinedIcon />,
        to: `/sites/${siteSlug}/settings?tab=script_tag&moduleId=${encodeURIComponent(
          moduleId
        )}`,
      },
    ],
    [moduleId, siteSlug]
  );

  return <TableActions actionMenus={actionMenus} />;
};
